<template>
    <advanced-thumbnail-impl
        :alt="altComputed"
        :background-position="dataComputed.alignment"
        :background-size="backgroundSize"
        :background-type="backgroundType"
        :shadow="false"
        :thumb="dataComputed.background_image" />
    <!--
        <div :class="{'bg-checkered': hasTransparency}">
            <div :style="elementStyle"
                 class="preview-picture-element">
                <slot />
            </div>
        </div>-->
</template>

<script>
import AdvancedThumbnailImpl from '../../../common/advanced-thumbnail-impl.vue'

export default {
    components: { AdvancedThumbnailImpl },
    inject: {
        /** @type {PublishInjectInfoTable} */
        publishInfoTable: {}
    },
    props: {
        /** @type {PublishElementDataCommon | PublishElementDataPicture} */
        data: Object,
        alt: String,
        sizeRatio: Number
    },
    computed: {
        hasTransparency() {
            return this.dataComputed.background_image?.indexOf('png', this.dataComputed.background_image?.lastIndexOf('.')) >= 0
        },
        backgroundType() {
            return (this.hasTransparency || ['original', 'aspect_fit'].includes(this.dataComputed.stretch)) ? 'checkered' : 'solid'
        },
        /** @returns {string | null} */
        backgroundSize() {
            switch (this.dataComputed.stretch) {
                case 'original':
                    return `${this.dataComputed.width * this.sizeRatio}px ${this.dataComputed.height * this.sizeRatio}px`
                default:
                case 'frame':
                    return '100% 100%';
                case 'aspect_fit':
                    return 'contain'
                case 'aspect_fill':
                    return 'cover'
            }
        },
        dataComputed() {
            return this.data ?? this.publishInfoTable.element.data
        },
        altComputed() {
            return this.alt ?? this.publishInfoTable.element.alt
        },
    }
}
</script>
